exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._23wDhqTzTGlfWmDaMuO3Pr{display:inline-block}html[dir=ltr] ._23wDhqTzTGlfWmDaMuO3Pr{padding-right:10px}html[dir=rtl] ._23wDhqTzTGlfWmDaMuO3Pr{padding-left:10px}", ""]);

// exports
exports.locals = {
	"spinner": "_23wDhqTzTGlfWmDaMuO3Pr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/owa-sharing-accept/lib/styles/SharingAcceptButton.scss
// module id = 5811
// module chunks = 96